export class ServerImportField {
    constructor(public fieldName:string, public displayName:string, public required:boolean, public columnIndex:number) {
    }

    static parseJson(json:any):ServerImportField {
        var entity:ServerImportField = new ServerImportField(
            json.fieldName,
            json.displayName,
            json.required,
            null
        );
        return entity;
    }
}
